import React from "react";
import { SidebarProvider } from "../context/SidebarContext";
import Sidebar from "../components/AdminPortal/Sidebar";
import TopNavbar from "../components/AdminPortal/TopNavbar";
import { UserProvider } from "../context/UserContext";

const MainLayout = ({ children }) => {
  return (
    <UserProvider>
      <SidebarProvider>
        <div className="flex">
          {/* Sidebar */}
          <Sidebar />

          <div className="flex flex-col w-full">
            {/* TopBar */}
            <TopNavbar />
            <div className="flex-1 p-4">{children}</div>
          </div>
        </div>
      </SidebarProvider>
    </UserProvider>
  );
};

export default MainLayout;
